// eslint-disable-next-line no-restricted-globals
export const downloadLink = `${location.protocol}//${location.host}/api/v1/download/`;